const pino = require('pino')
let devMode = process.env.NODE_ENV === 'development'
let baseLogger = devMode ? pino({
    prettyPrint: {
         colorize: true
    }
  }) : pino({
      messageKey: 'message', timestamp: () => `,"@timestamp":"${ new Date(Date.now()).toISOString() }"`
    })
export const logServer = baseLogger.child({
    application: 'ica-web-frontend'
})

export const log = (message, customAttributes) => {
    const isServerSide = typeof window === "undefined"
    if (isServerSide) {
        logServer.error(message)
    } else {
        console.error(message)
        if(window.NREUM) {
            window.NREUM.noticeError(message, {
                ...customAttributes, isServerSide,
            })
        }
    }
}